import { render, staticRenderFns } from "./totalRow.vue?vue&type=template&id=a40ed4cc&scoped=true&"
import script from "./totalRow.vue?vue&type=script&lang=js&"
export * from "./totalRow.vue?vue&type=script&lang=js&"
import style0 from "./totalRow.vue?vue&type=style&index=0&id=a40ed4cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40ed4cc",
  null
  
)

export default component.exports